var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M13.8833 3.83334L16.1667 6.11667C16.805 6.72481 16.8311 7.73472 16.225 8.37501L8.72501 15.875C8.45337 16.1444 8.09734 16.3121 7.71667 16.35L4.24167 16.6667H4.16667C3.94517 16.668 3.73227 16.581 3.57501 16.425C3.3992 16.2499 3.31061 16.0055 3.33334 15.7583L3.69167 12.2833C3.72959 11.9027 3.89731 11.5466 4.16667 11.275L11.6667 3.77501C12.3132 3.2288 13.2664 3.25388 13.8833 3.83334ZM11.1 6.66667L13.3333 8.90001L15 7.27501L12.725 5.00001L11.1 6.66667Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcEdit);
export default __webpack_public_path__ + "static/media/ic_edit.56bdd99a.svg";
export { ForwardRef as ReactComponent };